declare namespace $ {

	type $shm_projects_catalog_head__title_shm_projects_catalog_1 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_projects_catalog_head['title'] >
	>
	type $shm_projects_catalog_head__title_uri_shm_projects_catalog_2 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['projects_uri'] >
		,
		ReturnType< $shm_projects_catalog_head['title_uri'] >
	>
	type $shm_projects_catalog_head__filter_shm_projects_catalog_3 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['filter'] >
		,
		ReturnType< $shm_projects_catalog_head['filter'] >
	>
	type $shm_projects_catalog_head__add_shm_projects_catalog_4 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['add'] >
		,
		ReturnType< $shm_projects_catalog_head['add'] >
	>
	type $shm_projects_catalog_head__settings_hint_shm_projects_catalog_5 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_projects_catalog_head['settings_hint'] >
	>
	type $shm_projects_catalog_head__settings_content_shm_projects_catalog_6 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_settings_content'] >
		,
		ReturnType< $shm_projects_catalog_head['settings_content'] >
	>
	type $shm_projects_catalog_head__Close_shm_projects_catalog_7 = $mol_type_enforce<
		any
		,
		ReturnType< $shm_projects_catalog_head['Close'] >
	>
	type $shm_tree__roots_shm_projects_catalog_8 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_roots'] >
		,
		ReturnType< $shm_tree['roots'] >
	>
	type $shm_tree__children_shm_projects_catalog_9 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_children'] >
		,
		ReturnType< $shm_tree['children'] >
	>
	type $shm_tree__expanded_shm_projects_catalog_10 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_expanded'] >
		,
		ReturnType< $shm_tree['expanded'] >
	>
	type $shm_tree__expanded_key_shm_projects_catalog_11 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_expanded_key'] >
		,
		ReturnType< $shm_tree['expanded_key'] >
	>
	type $shm_tree__Item_shm_projects_catalog_12 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['Project_link'] >
		,
		ReturnType< $shm_tree['Item'] >
	>
	type $mol_string__value_shm_projects_catalog_13 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['new_project_title'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_form_field__name_shm_projects_catalog_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_projects_catalog_15 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['New_project_title'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_button_major__title_shm_projects_catalog_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__enabled_shm_projects_catalog_17 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['new_project_create_enabled'] >
		,
		ReturnType< $mol_button_major['enabled'] >
	>
	type $mol_button_major__click_shm_projects_catalog_18 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['new_project_create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_minor__title_shm_projects_catalog_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_projects_catalog_20 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['new_project_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_projects_catalog_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_24 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['timeline_day_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_28 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_30 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_projects_catalog_32 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_table_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_projects_catalog_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_scroll__sub_shm_projects_catalog_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_37 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['timeline_event_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_shm_projects_catalog_38 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_catalog_39 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_catalog_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__arg_shm_projects_catalog_41 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_version_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_catalog_42 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_version'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_catalog_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_44 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_projects_catalog_47 = $mol_type_enforce<
		({ 
			'title': ReturnType< $shm_projects_catalog['project_activity_title'] >,
			'data-status': ReturnType< $shm_projects_catalog['project_activity_status'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_projects_catalog_48 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_activity_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_49 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_projects_catalog_53 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__head_shm_projects_catalog_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['head'] >
	>
	type $mol_page__body_shm_projects_catalog_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__title_shm_projects_catalog_56 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_catalog_57 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__title_shm_projects_catalog_58 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_projects_catalog_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_shm_projects_catalog_60 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_shm_projects_catalog_61 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['timeline_event_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__title_shm_projects_catalog_62 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['timeline_event_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__sub_shm_projects_catalog_63 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_64 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_catalog_65 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_link__arg_shm_projects_catalog_66 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_projects_catalog_67 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_projects_catalog_68 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__click_shm_projects_catalog_69 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_read'] >
		,
		ReturnType< $mol_link['click'] >
	>
	type $mol_link__sub_shm_projects_catalog_70 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $shm_projects_page__project_id_shm_projects_catalog_71 = $mol_type_enforce<
		ReturnType< $shm_projects_catalog['project_id'] >
		,
		ReturnType< $shm_projects_page['project_id'] >
	>
	export class $shm_projects_catalog extends $mol_book2 {
		catalog_pages( ): readonly(any)[]
		projects_uri( ): string
		filter( next?: string ): string
		add( next?: any ): any
		List_head( ): $shm_projects_catalog_head
		project_roots( ): readonly(any)[]
		project_children( id: any): readonly(any)[]
		project_expanded( id: any, next?: boolean ): boolean
		project_expanded_key( id: any): string
		Projects( ): $shm_tree
		new_project_title( next?: string ): string
		New_project_title( ): $mol_string
		New_project_title_field( ): $mol_form_field
		new_project_create_enabled( ): boolean
		new_project_create( next?: any ): any
		New_project_create( ): $mol_button_major
		new_project_cancel( next?: any ): any
		New_project_cancel( ): $mol_button_minor
		New_project_actions( ): $mol_view
		New_project_form( ): $mol_view
		Timeline_title( ): $mol_view
		timeline_day_rows( ): readonly(any)[]
		Timeline_days( ): $mol_view
		Timeline( ): $mol_view
		Project_head_title( ): $mol_view
		Project_head_version( ): $mol_view
		Project_head_prerelease( ): $mol_view
		Project_head_release( ): $mol_view
		Project_head_date( ): $mol_view
		Project_table_head( ): $mol_view
		project_table_rows( ): readonly(any)[]
		Project_rows( ): $mol_list
		Project_table( ): $mol_view
		Catalog_content( ): $mol_view
		Catalog_scroll( ): $mol_scroll
		timeline_day_title( id: any): string
		Timeline_day_title( id: any): $mol_view
		timeline_event_rows( id: any): readonly(any)[]
		Timeline_events( id: any): $mol_view
		timeline_event_arg( id: any): Record<string, any>
		timeline_event_title( id: any): string
		project_arg( id: any): Record<string, any>
		project_title( id: any): string
		Project_row_title( id: any): $mol_link
		project_version_arg( id: any): Record<string, any>
		project_version( id: any): string
		Project_row_version( id: any): $mol_link
		project_prerelease( id: any): string
		Project_row_prerelease( id: any): $mol_view
		project_release( id: any): string
		Project_row_release( id: any): $mol_view
		project_version_date( id: any): string
		Project_row_date( id: any): $mol_view
		project_current( id: any): boolean
		project_read( id: any, next?: any ): any
		project_activity_title( id: any): string
		project_activity_status( id: any): string
		project_activity_content( id: any): readonly(any)[]
		Project_activity( id: any): $mol_view
		Project_title( id: any): $mol_view
		Project_title_row( id: any): $mol_view
		project_identifier( id: any): string
		Project_id( id: any): $mol_view
		Project_label( id: any): $mol_view
		project_id( id: any): string
		projects_list_visible( next?: boolean ): boolean
		new_project_opened( next?: boolean ): boolean
		project_selected( ): string
		project_settings_content( ): readonly($mol_view_content)[]
		pages( ): ReturnType< $shm_projects_catalog['catalog_pages'] >
		Menu_page( ): $mol_page
		New_project_page( ): $mol_page
		Catalog_page( ): $mol_page
		Timeline_day( id: any): $mol_view
		Timeline_event( id: any): $mol_link
		Timeline_empty( id: any): $mol_view
		Project_row( id: any): $mol_view
		Project_link( id: any): $mol_link
		Project( id: any): $shm_projects_page
	}
	
}

//# sourceMappingURL=catalog.view.tree.d.ts.map